export default function randomColor(tryThis){
  if(tryThis){
    // try using the provided string as a color
    const div = document.createElement('div').style
    div.color=tryThis
    if (div.color) return div.color
  }

  // genereate random color
  return '#' + (Math.floor(Math.random() * 15728639) + 1048576).toString(16)
}